import UserManagement from "./user-management.page";

export default UserManagement;
